class OkeReviewsWidget {
  constructor() {
    this.init();
  }

  init() {
    this.isMobile = window.innerWidth < 1024;
    this.reviewControls = document.querySelector(".okeReviews-reviews-controls");
    this.toggleButton = document.querySelector(".okeReviews-filterToggle");
    this.filterWrapper = document.querySelector(".okeReviews-reviews-controls-filters");
    this.reviewMain = document.querySelector(".js-okeReviews-reviews-main");
    this.reviewHeaderSetup();
    this.observeReviewsMainChanges();
    this.moveReviewComponents();

    if (this.isMobile) {
      this.createEmbedLightBox(this.reviewControls);
      this.sectionHeader = document.getElementById("section-header");
      if (this.sectionHeader) {
        this.createEmbedLightBox(this.sectionHeader);
      }
      this.embedLightbox = document.querySelectorAll(".okeReview-embed-lightbox");
      if (this.embedLightbox) {
        this.embedLightboxAction();
      }
      this.userInfoModalSetup();
      this.filterModalSetup();
    }
  }
  createEmbedLightBox(target) {
    let embedLightbox;
    embedLightbox = document.createElement("div");
    embedLightbox.classList.add("okeReview-embed-lightbox");
    if (this.sectionHeader == target) {
      embedLightbox.classList.add("header-embed-lightbox");
    }
    target.appendChild(embedLightbox);
  }

  embedLightboxAction() {
    this.embedLightbox.forEach((lightbox) => {
      lightbox.addEventListener("click", () => {
        if (this.filterWrapper.style.display === "block") {
          this.toggleButton.click();
        } else {
          this.hideUserInfoModal();
        }
      });
    });
  }

  userInfoModalSetup() {
    this.creatInfoModal();
    this.infoButtonClickListener();
    this.userModalClose();
  }

  creatInfoModal() {
    const userModal = document.createElement("div");
    userModal.classList.add("okReviews-user-modal", "okReviews-modal");
    userModal.insertAdjacentHTML("afterbegin",'<div class="okeReviews-modal-header"><span class="user-modal-header-title">USER INFO</span> <span class="user-modal-close okeReview-modal-close"></span></div>');
    userModal.insertAdjacentHTML("beforeend",'<div class="okeReviews-modal-content"></div>');
    if (this.reviewMain) {
      this.reviewMain.parentNode.insertBefore(userModal, this.reviewMain);
    }
  }

  infoButtonClickListener() {
    if (this.reviewMain) {
      const buttons = this.reviewMain.querySelectorAll(".user-info-button");
      if (buttons) {
        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const parent = button.parentElement;
            const sibling = parent.querySelector(".okeReviews-review-side-inner");
            const userModalContent = document.querySelector(".okReviews-user-modal .okeReviews-modal-content");
            if (sibling && userModalContent) {
              const clonedSibling = sibling.cloneNode(true);
              userModalContent.appendChild(clonedSibling);
            }
            this.showUserInfoModal();
          });
        });
      }
    }
  }
  userModalClose() {
    const userModalClose = document.querySelector(".user-modal-close");
    if (userModalClose) {
      userModalClose.addEventListener("click", () => {
        this.hideUserInfoModal();
      });
    }
  }
  showUserInfoModal() {
    const userModal = document.querySelector(".okReviews-user-modal");
    if (userModal) {
      userModal.classList.add("active");
      if (this.embedLightbox) {
        this.embedLightbox.forEach((lightbox) => {
          lightbox.classList.add("active");
        });
      }
      document.body.classList.add("noscroll");
    }
  }
  hideUserInfoModal() {
    const userModal = document.querySelector(".okReviews-user-modal");
    if (userModal) {
      userModal.classList.remove("active");
      const userModalContent = userModal.querySelector(".okeReviews-modal-content");
      if (userModalContent) {
        userModalContent.innerHTML = "";
      }
      if (this.embedLightbox) {
        this.embedLightbox.forEach((lightbox) => {
          lightbox.classList.remove("active");
        });
      }
      document.body.classList.remove("noscroll");
    }
  }

  observeReviewsMainChanges() {
    if (this.reviewMain) {
      const observer = new MutationObserver(() => {
        this.moveReviewComponents();
        if (this.isMobile) {
          this.infoButtonClickListener();
        }
      });
      observer.observe(this.reviewMain, { childList: true });
    }
  }

  moveReviewComponents() {
    const reviewsContainers = document.querySelectorAll(".okeReviews-review");
    if (reviewsContainers) {
      reviewsContainers.forEach((review) => {
        const reviewerDetailsInner = review.querySelector(".okeReviews-review-reviewer-profile-details-inner");
        const reviewDate = review.querySelector(".okeReviews-review-date");
        const reviewerAttr = review.querySelector(".okeReviews-review-reviewer-attributes");
        if (!this.isMobile) {
          const reviewerGridLeft = review.querySelector(".okeReviews-review-primary-grid-left");
          const reviewerHelpful = review.querySelector(".okeReviews-review-helpful");

          if (reviewerHelpful && reviewerGridLeft) {
            reviewerGridLeft.insertAdjacentElement("beforeend",reviewerHelpful);
          }
        } else {
          const reviewLeftSide = review.querySelector(".okeReviews-review-side");
          if (reviewLeftSide) {
            reviewLeftSide.insertAdjacentHTML("beforeend",'<span class="user-info-button">User Info</span>');
          }
        }
        if (reviewerDetailsInner) {
          if (reviewerAttr) {
            reviewerDetailsInner.insertAdjacentElement("afterend",reviewerAttr);
          }
          if (reviewDate) {
            reviewerDetailsInner.insertAdjacentElement("afterend", reviewDate);
          }
        }
      });
    }
  }

  reviewHeaderSetup() {
    this.additionalFilterData();
    if (this.isMobile) {
      const reviewsAggregateSummary = document.querySelector(".okeReviews-reviewsAggregate-summary");
      const reviewsAggregatePrimary = document.querySelector(".okeReviews-reviewsAggregate-primary");
      if (reviewsAggregateSummary && reviewsAggregatePrimary) {
        reviewsAggregatePrimary.insertAdjacentElement("beforeend",reviewsAggregateSummary);
      }
    } else {
      const filterToggle = document.querySelector(".okeReviews-reviews-controls-filterToggle");
      if (filterToggle) {
        filterToggle.insertAdjacentHTML("beforeend",'<span class="filter-title"> Filter by</span>');
      }
      document.addEventListener("click", (event) =>
        this.handleDocumentClick(event)
      );
    }
    const filterContainers = document.querySelectorAll(".js-okeReviews-filter");
    if (filterContainers) {
      const filtersContent = document.querySelector(".okeReviews-filters-content");
      if (filtersContent) {
        this.resetFilterDiv = this.createResetFilterButton(filtersContent);
      }

      const filterClearButtons = filtersContent ? filtersContent.querySelectorAll(".okeReviews-filter-clear") : null;
      if (this.resetFilterDiv && filterClearButtons) {
        this.resetFilterDiv.addEventListener("click", () =>this.handleResetFilterClick(filterClearButtons));
      }

      filterContainers.forEach((container) => {
        this.setupFilterContainer(container);
      });
    }
  }
  filterModalSetup() {
    if (this.filterWrapper) {
      this.filterWrapper.classList.add("okReviews-modal");
      const filterContainer = this.filterWrapper.querySelector(".js-okeReviews-filters");
      if (filterContainer) {
        filterContainer.insertAdjacentHTML("afterbegin",'<div class="okeReviews-modal-header"><span class="filter-header-title"> FILTER REVIEWS </span> <span class="filter-modal-close okeReview-modal-close"></span></div>');
      }
      if (this.toggleButton) {
        const closeModalButton = filterContainer?.querySelector(".filter-modal-close");
        const buttonSticky = document.querySelector(".product__buttons-sticky");
        this.toggleButton.addEventListener("click", () => {
          var filterWrapperState = this.filterWrapper.style.display;
          this.filterWrapper.style.display = filterWrapperState === "none" || filterWrapperState === "" ? "block" : "none";
          if (this.embedLightbox) {
            this.embedLightbox.forEach((lightbox) => {
              lightbox.classList.toggle("active");
            });
          }
          document.body.classList.toggle("noscroll");
          if (buttonSticky) {
            buttonSticky.classList.toggle("hidden");
          }
        });

        closeModalButton?.addEventListener("click", () => {
          this.toggleButton.click();
        });
      }
    }
  }

  additionalFilterData() {
    const additionaDataBlock = document.createElement("div");
    additionaDataBlock.classList.add("additional-filter-data");
    const reviewControls = document.querySelector(".okeReviews-reviews-controls");

    if (reviewControls) {
      reviewControls.insertAdjacentElement("afterend", additionaDataBlock);
      const reviewCount = document.querySelector(".okeReviews-reviews-controls-reviewCount");

      if (reviewCount) {
        additionaDataBlock.insertAdjacentElement("beforeend", reviewCount);
      }

      const appliedFilterCount = document.createElement("div");
      appliedFilterCount.classList.add("applied-filter-count");
      additionaDataBlock.insertAdjacentElement("beforeend", appliedFilterCount);
    }
  }

  createResetFilterButton(parentElement) {
    const resetFilterDiv = document.createElement("div");
    resetFilterDiv.className = "reset-filter";
    resetFilterDiv.innerHTML = "<span>Reset Filters</span>";
    parentElement.insertAdjacentElement("beforeend", resetFilterDiv);
    return resetFilterDiv;
  }

  handleResetFilterClick(filterClearButtons) {
    filterClearButtons.forEach((button) => button.click());
  }

  setupFilterContainer(container) {
    if (!this.isMobile) {
      const filterTitle = container.querySelector(".okeReviews-filter-title");
      const filterList = container.querySelector(".okeReviews-filter-list");

      if (filterTitle) {
        this.createFiltersCountElement(filterTitle);
        if (filterList) {
          filterTitle.addEventListener("click", () =>
            this.handleFilterTitleClick(filterList)
          );
        }
      }
    }
    this.observeFilterContainerChanges(container);
  }

  createFiltersCountElement(parentElement) {
    const filtersCount = document.createElement("div");
    filtersCount.className = "filters-count";
    parentElement.appendChild(filtersCount);
  }

  handleFilterTitleClick(filterList) {
    var filterListState = filterList.style.display;
    this.closeAllFilters();
    filterList.style.display =
      filterListState === "none" || filterListState === "" ? "flex" : "none";
  }

  closeAllFilters() {
    const filterContainers = document.querySelectorAll(".js-okeReviews-filter");
    if (filterContainers) {
      filterContainers.forEach((container) => {
        const filterList = container.querySelector(".okeReviews-filter-list");
        if (filterList) {
          filterList.style.display = "none";
        }
      });
    }
  }

  observeFilterContainerChanges(container) {
    const config = { attributes: true, childList: false, subtree: false };
    const observer = new MutationObserver((mutationsList) =>
      this.handleFilterContainerChanges(mutationsList)
    );
    observer.observe(container, config);
  }

  handleFilterContainerChanges(mutationsList) {
    const isActive = this.activeFilterChecked();
    if (isActive) {
      this.calculateActiveFiltersCount(mutationsList[0]?.target);
      this.resetFilterDiv.style.display = "block";
    } else {
      const filterCount = mutationsList[0]?.target.querySelector(".filters-count");
      if (filterCount) {
        filterCount.textContent = "";
        filterCount.style.display = "none";
      }
      this.resetFilterDiv.style.display = "none";
    }
    this.calculateTotalActiveFiltersCount();
  }

  activeFilterChecked() {
    const filterContainers = document.querySelectorAll(".js-okeReviews-filter");
    let isActive = false;
    filterContainers.forEach((container) => {
      if (container.classList.contains("is-okeReviews-active")) {
        isActive = true;
      }
    });
    return isActive;
  }

  handleDocumentClick(event) {
    const isFilterContainer = event.target.closest(".js-okeReviews-filter");
    if (!isFilterContainer) {
      this.closeAllFilters();
    }
  }

  calculateActiveFiltersCount(container) {
    const checkboxes = container.querySelectorAll(".okeReviews-filter-list-item-checkbox");
    let checkedCount = 0;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        checkedCount++;
      }
    });
    const filterCount = container.querySelector(".filters-count");
    if (filterCount) {
      if (checkedCount > 0) {
        filterCount.textContent = checkedCount;
        filterCount.style.display = "block";
      }
    }
  }

  calculateTotalActiveFiltersCount() {
    const filtersContent = document.querySelector(".okeReviews-filters-content");
    if (filtersContent) {
      const checkboxes = filtersContent.querySelectorAll(".okeReviews-filter-list-item-checkbox");
      let checkedCount = 0;
      if (checkboxes) {
        checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            checkedCount++;
          }
        });
      }

      const totalCount = document.querySelector(".applied-filter-count");
      const filterCount = document.querySelector(".js-okeReviews-filterCount");
      if (totalCount && filterCount) {
        if (checkedCount > 0) {
          totalCount.textContent = `${checkedCount} Filters Applied`;
          totalCount.style.display = "block";
          filterCount.textContent = checkedCount;
          filterCount.style.display = "block";
        } else {
          totalCount.textContent = "";
          totalCount.style.display = "none";
          filterCount.textContent = "";
          filterCount.style.display = "none";
        }
      }
    }
  }
}
document.addEventListener("DOMContentLoaded", function() {
  window.okeReviewsWidgetOnInit = function() {
    new OkeReviewsWidget();
  }
  document.addEventListener("DOMContentLoaded", window.okeReviewsWidgetOnInit);
});